import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { getLocalizedTitle } from '@src/services/educatorsSurvey';

const NO_LETTER_SPACING = { letterSpacing: 0 };

const QuestionTags = ({ question, selectedOptions, onSelect }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="survey-tags">
      {question.options.map((option) => (
        <button
          key={option.key}
          type="button"
          className="survey-tag"
          aria-pressed={selectedOptions.some((item) => item.key === option.key)}
          onClick={() => onSelect(option)}
        >
          <Typography
            variant="body-14-semibold"
            color={COLOR.indigo.default}
            style={NO_LETTER_SPACING}
          >
            {getLocalizedTitle(option.title, language)}
          </Typography>
        </button>
      ))}
    </div>
  );
};

export default QuestionTags;
